import React, { Component } from "react";
import { MnemoLoading, BoxDanger, Title } from "components/misc";
import { networkErrorHelper } from "libs";
import { MTable } from "components/table";
import { Col, Container, Row } from "design-react-kit";
import { withRouter } from "react-router-dom";
import { revisionService } from "libs/api/revisionService";
import { LESSON_ACTIVITY_TYPES, ROUTES } from "const";
import { getCurrentRevisor } from "store/actions";

class ReviewHistoryLAC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      rndKey: 0,
      payload: [],
      revisorIdCompany: null,
    };
  }

  //--- ---

  tableConfig = {
    columns: [
      { id: "index", Header: "#", Cell: ({ row }) => row.index + 1 },
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "courseCode",
        Header: "Codice Corso",
        accessor: "courseCode",
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          window.location.href = ROUTES.CURRENT_REVISION_LESSON_ACTIVITY_COMPANY_DETAIL + "/" + value;
        },
      },
    ],
  };

  //--- ---

  componentDidMount() {
    const { context } = this.props.match.params;

    const revisor = getCurrentRevisor(context);
    const revisorIdCompany = revisor?.id;

    if (revisorIdCompany) {
      this.setState({ revisorIdCompany });
      this.loadRemote(revisorIdCompany);
    } else this.loadRemote();
  }

  componentDidUpdate(prevProps) {
    const { activityType } = this.props.match.params;
    const { revisorIdCompany } = this.state;

    if (prevProps.match.params.activityType !== activityType) {
      this.loadRemote(revisorIdCompany);
    }
  }

  loadRemote(revisorIdCompany) {
    this.setState({ loading: true });

    const { activityType, status } = this.props.match.params;

    const filter = {
      status,
      revisorIdCompany,
      lessonType: "training",
      activityType,
    };

    revisionService
      .listAllLessonActivityCompany(filter)
      .then(({ data }) => {
        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(data.payload.lessonActivities).forEach(([key, val]) => {
          items.push(val);
        });

        this.setState({
          loading: false,
          payload: items,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
        //--- end: prepare reactTable ---
      })
      .catch((error) => {
        if (!networkErrorHelper.is404(error)) {
          console.log(error);
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
            loading: false,
            loadingError: true,
          });
        }
      });
  }

  //--- ---

  render() {
    const { loading } = this.state;
    const { activityType } = this.props.match.params;

    return (
      <>
        <Row>
          <Col>
            <Title subtitle={activityType === LESSON_ACTIVITY_TYPES.ABILITAZIONI ? "Percorsi Abilitanti" : "TFA XI ciclo"}>Storico Revisioni</Title>
          </Col>
        </Row>

        <hr />
        <section className="my-4">
          {loading ? (
            <MnemoLoading></MnemoLoading>
          ) : (
            <Container>
              <MTable key={this.state.rndKey} tableData={this.state.payload} tableConfig={this.tableConfig} />
            </Container>
          )}

          {this.state.payload.length === 0 && (
            <BoxDanger key="nrp-1" className="my-3">
              <div className="small text-info">Non ci sono dati da mostrare in database.</div>
            </BoxDanger>
          )}
        </section>
      </>
    );
  }
}

export default withRouter(ReviewHistoryLAC);
